module.exports = __webpack_public_path__ + "static/media/load.9b4a1bcf.svg";